<template>
  <ontos-dialog :model-value="true" :fullscreen="$vuetify.display.smAndDown" max-width="1100px"
            @update:model-value="onDialogInput">
    <v-card class="image-preview">
      <v-card-title class="py-2">
        <ontos-page-header :title="title" :level="2">
          <!-- O ✕ padrão dos modais, nos controles da janela — e não um botão próprio -->
          <template #controls>
            <ontos-dialog-actions @closed="$emit('closed')"/>
          </template>
        </ontos-page-header>
      </v-card-title>
      <v-card-text class="image-preview-body">
        <!-- max-height em vh e não px: em tela baixa a imagem não pode empurrar o
             título para fora. contain preserva a proporção sem cortar. -->
        <img :src="src" :alt="title" class="image-preview-image">
      </v-card-text>
    </v-card>
  </ontos-dialog>
</template>
<script lang="ts">
import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'

/**
 * Mostra uma imagem ampliada. Só exibe — não carrega nada nem conhece instância.
 *
 * Quem hospeda é a tela (listagem, ficha), não a célula: um estado guardado no
 * PropertyValue ficaria preso à posição da célula e trocaria de imagem ao ordenar
 * ou filtrar.
 */
@Component({emits: ['closed'], name: 'ontos-image-preview-dialog'})
class ImagePreviewDialog extends Vue {
  @Prop({type: String, required: true}) readonly src!: string
  @Prop({type: String, default: ''}) readonly title!: string

  onDialogInput(open: boolean) {
    if (!open) this.$emit('closed')
  }
}

export default toNative(ImagePreviewDialog)
</script>
<style scoped>
.image-preview-body {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0;
}

.image-preview-image {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
}
</style>
